import React from "react";
export default function FindingYourWay() {
  return <section data-section-id="225132" id="our-location" className="w-full py-16 md:py-24 bg-background text-foreground">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center">
        <div className="relative w-full max-w-5xl mx-auto aspect-video md:aspect-[21/9] overflow-hidden bg-muted shadow-xl rounded-md">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1655661/img/johns_creek_neighborhood_aerial.png" alt="Premium direct mail coverage in Johns Creek and Metro Atlanta" className="w-full h-full object-cover" />
          <div className="absolute bottom-0 left-0 bg-secondary px-6 py-4 md:px-10 md:py-6">
            <span className="text-secondary-foreground font-default font-bold text-xl md:text-3xl uppercase tracking-wider">
              Serving Metro Atlanta
            </span>
          </div>
        </div>
        
        <p className="mt-8 md:mt-12 max-w-2xl text-center font-default text-base md:text-lg text-foreground/80 leading-relaxed">
          The Peachtree Post proudly serves the high-income households of Johns Creek, GA and the surrounding Metro Atlanta area. Our premium co-op mailers are strategically delivered to over 2,500 targeted residences, ensuring your business reaches the most qualified local homeowners.
        </p>
      </div>
    </section>;
}